import { useQuery, useMutation } from '@tanstack/react-query';
import {
  fetchTraceableCommentsByFieldName,
  saveTraceableComment,
} from 'services/traceable-comment';

// Fetch traceable comments by field name
export const useGetTraceableComments = (params, visibleComment) => {
  return useQuery({
    queryKey: ['traceable-comments', params],
    queryFn: async () => {
      const data = await fetchTraceableCommentsByFieldName(params);
      return data.data || [];
    },
    staleTime: 0,
    cacheTime: 0,
    enabled: visibleComment, // Only fetch when visibleComment is true
  });
};

// Save comment (works for both Supplier and QA)
export const useSaveTraceableComment = (options = {}) => {
  return useMutation({
    mutationFn: async (payload) => {
      const response = await saveTraceableComment(payload);
      return response?.data;
    },
    ...options, // optional callbacks: onSuccess, onError, etc.
  });
};
